export function deleteSavedUser() {
    const BASE_KEY = "ANeT/SelfService/login";
    const REMEMBERED_USERNAME_KEY = BASE_KEY + "/user/username";
    const REMEMBERED_PASSWORD_KEY = BASE_KEY + "/user/password";
    localStorage.setItem(REMEMBERED_USERNAME_KEY, "");
    localStorage.setItem(REMEMBERED_PASSWORD_KEY, "");
}
